























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardAsesmenPopulasiKhusus from "../tabs/rekam-medis/populasikhusus/CardAsesmenPopulasiKhusus.vue";
import AsesmenPopulasiKhususStore from "@/store/modules/AsesmenPopulasiKhususStore";

@Component({
  components: {
    CardAsesmenPopulasiKhusus
  }
})
export default class AsesmenPopulasiKhususPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;

  get loading() {
    return AsesmenPopulasiKhususStore.loading;
  }

  get stateData() {
    return AsesmenPopulasiKhususStore.data;
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.stateData) {
      this.getByRegister();
    }
  }

  mounted() {
    if (this.isActive) {
      this.getByRegister();
    }
  }

  async getByRegister() {
    await AsesmenPopulasiKhususStore.getByRegister(this.register);
  }
}
